import React from 'react';

const SocialLinks = () => {
  // Generate a unique ID for Instagram gradient to avoid conflicts
  const instagramGradientId = `instagram-gradient-${Math.random().toString(36).substr(2, 9)}`;

  const socials = [
    {
      name: 'Facebook',
      href: '#',
      icon: (
        <path
          fill="#1877F2"
          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 
          1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 
          1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
        />
      )
    },
    {
      name: 'Twitter',
      href: '#',
      icon: (
        <path
          fill="#1DA1F2"
          d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 
          0-.178 0-.355-.012-.53A8.348 8.348 0 0022 
          5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 
          001.804-2.27 8.224 8.224 0 01-2.605.996 
          4.107 4.107 0 00-6.993 3.743 11.65 11.65 
          0 01-8.457-4.287 4.106 4.106 0 001.27 
          5.477A4.072 4.072 0 012.8 9.713v.052a4.105 
          4.105 0 003.292 4.022 4.095 4.095 0 
          01-1.853.07 4.108 4.108 0 003.834 
          2.85A8.233 8.233 0 012 18.407a11.616 
          11.616 0 006.29 1.84"
        />
      )
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/adventurescanner2024/',
      icon: (
        <>
          <defs>
            <linearGradient id={instagramGradientId} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FD5949" />
              <stop offset="45%" stopColor="#D6249F" />
              <stop offset="100%" stopColor="#285AEB" />
            </linearGradient>
          </defs>
          <path
            fill={`url(#${instagramGradientId})`}
            d="M12 2.163c3.204 0 3.584.012 4.85.07 
            3.252.148 4.771 1.691 4.919 4.919.058 
            1.265.069 1.645.069 4.849 0 
            3.205-.012 3.584-.069 4.849-.149 
            3.225-1.664 4.771-4.919 
            4.919-1.266.058-1.644.07-4.85.07-3.204 
            0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 
            0-3.204.013-3.583.07-4.849.149-3.227 
            1.664-4.771 4.919-4.919 1.266-.057 
            1.645-.069 4.849-.069zM12 0C8.741 
            0 8.333.014 7.053.072 2.695.272.273 
            2.69.073 7.052.014 8.333 0 8.741 0 
            12c0 3.259.014 3.668.072 4.948.2 
            4.358 2.618 6.78 6.98 6.98C8.333 
            23.986 8.741 24 12 24c3.259 0 
            3.668-.014 4.948-.072 4.354-.2 
            6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 
            0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 
            15.259 0 12 0zm0 5.838a6.162 6.162 0 
            100 12.324 6.162 6.162 0 000-12.324zM12 
            16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 
            1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
          />
        </>
      )
    },
    {
      name: 'LinkedIn',
      href: '#',
      icon: (
        <path
          fill="#0A66C2"
          d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 
          0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 
          1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 
          5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 
          0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 
          2.063 0 1.139-.925 2.065-2.064 
          2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 
          0H1.771C.792 0 0 .774 0 1.729v20.542C0 
          23.227.792 24 1.771 24h20.451C23.2 24 24 
          23.227 24 22.271V1.729C24 .774 23.2 0 22.222 
          0h.003z"
        />
      )
    }
  ];

  return (
    <div className="mt-6">
      <h4 className="text-white font-bold mb-4">Follow Us</h4>
      <div className="flex space-x-3">
        {socials.map((social, index) => (
          <a
            key={index}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-white transition-all duration-200 hover:scale-110 hover:shadow-md"
            aria-label={social.name}
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5" xmlns="http://www.w3.org/2000/svg">
              {social.icon}
            </svg>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;
